import { render, staticRenderFns } from "./formGoogle.vue?vue&type=template&id=dd95c83c"
import script from "./formGoogle.vue?vue&type=script&lang=js"
export * from "./formGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd95c83c')) {
      api.createRecord('dd95c83c', component.options)
    } else {
      api.reload('dd95c83c', component.options)
    }
    module.hot.accept("./formGoogle.vue?vue&type=template&id=dd95c83c", function () {
      api.rerender('dd95c83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/formNetwork/formGoogle.vue"
export default component.exports